// Animate a clone of the product image flying into the cart icon.
// Purely decorative — wrapped in try/catch so it can never block add-to-cart.
function flyToCart(sourceEl) {
	try {
		if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
		if (!sourceEl) return;

		const cartIcons = Array.from(document.querySelectorAll('a[aria-label="Cart"]'));
		const cartIcon = cartIcons.find((el) => el.offsetParent !== null) || cartIcons[0];
		if (!cartIcon) return;

		const img = sourceEl.tagName === 'IMG' ? sourceEl : sourceEl.querySelector('img');
		const src = img ? (img.currentSrc || img.src) : null;
		if (!src) return;

		const from = (img || sourceEl).getBoundingClientRect();
		if (!from.width || !from.height) return;
		const to = cartIcon.getBoundingClientRect();

		// Cap the flying clone to a consistent size, centred on the source.
		const cap = 140;
		let w = from.width, h = from.height;
		if (w > cap) { h = h * (cap / w); w = cap; }
		const fromCX = from.left + from.width / 2;
		const fromCY = from.top + from.height / 2;
		const left = fromCX - w / 2;
		const top = fromCY - h / 2;

		const dx = (to.left + to.width / 2) - fromCX;
		const dy = (to.top + to.height / 2) - fromCY;

		const fly = document.createElement('img');
		fly.src = src;
		fly.className = 'fly-to-cart-img';
		fly.style.cssText = 'position:fixed;left:' + left + 'px;top:' + top + 'px;width:' + w + 'px;height:' + h + 'px;';
		document.body.appendChild(fly);

		const anim = fly.animate([
			{ transform: 'translate(0,0) scale(1)', opacity: 1 },
			{ transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 40) + 'px) scale(0.5)', opacity: 0.9, offset: 0.6 },
			{ transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.08)', opacity: 0.15 }
		], { duration: 750, easing: 'cubic-bezier(.5,-0.2,.7,.5)' });

		anim.onfinish = () => {
			fly.remove();
			cartIcon.classList.add('cart-bump');
			setTimeout(() => cartIcon.classList.remove('cart-bump'), 450);
		};
		anim.oncancel = () => fly.remove();
	} catch (e) { /* never block add-to-cart */ }
}

// Find the product image to fly, based on where the add happened.
function findFlySource(formEl) {
	const card = formEl.closest('.product-card');
	if (card) return card.querySelector('.product-card-picture._front img');
	if (formEl.closest('#choose-option-popup')) {
		return document.querySelector('#choose-option-popup .swiper-slide-active img')
			|| document.querySelector('#choose-option-popup [data-quick-view-slider] img');
	}
	return document.querySelector('.product-gallery-main-slider .swiper-slide-active img')
		|| document.querySelector('.product-gallery [data-product-media] img')
		|| document.querySelector('.product-gallery img');
}

function showCartToast(message, variant) {
	let toast = document.getElementById('cart-toast');
	if (!toast) {
		toast = document.createElement('div');
		toast.id = 'cart-toast';
		document.body.appendChild(toast);
	}
	const isError = variant === 'error';
	const text = message || document.body.dataset.addedText || 'Lagt i handlekurv';
	toast.className = 'cart-toast' + (isError ? ' _error' : '');
	toast.innerHTML = isError
		? '<span class="cart-toast-icon cart-toast-icon--error">!</span><span class="cart-toast-text"></span>'
		: '<span class="cart-toast-icon icon icon-checkmark"></span><span class="cart-toast-text"></span>';
	toast.querySelector('.cart-toast-text').textContent = text;
	// force reflow so the transition replays on rapid adds
	void toast.offsetWidth;
	toast.classList.add('show');
	clearTimeout(window.__cartToastTimer);
	window.__cartToastTimer = setTimeout(function () {
		toast.classList.remove('show');
	}, isError ? 3400 : 2600);
}

if (!customElements.get('product-form')) {
	customElements.define('product-form', class AddToCart extends HTMLElement {
		constructor() {
			super();
			this.form = this.querySelector('form[action$="/cart/add"]');
			this.productIdInput = this.form?.querySelector('[name=id]');
			this.addButtons = this.querySelectorAll('button[name="add"]');

			if (this.form && this.productIdInput) {
				this.productIdInput.disabled = false;
				this.form.addEventListener('submit', this.formSubmit.bind(this));
			}
		}

		async formSubmit(evt) {

			evt.preventDefault();

			if (!this.productIdInput?.value) {
				this.variantError();
				return;
			}

			document.querySelector('.product-error')?.remove();
			this.removeErrorsBlock();
			this.toggleLoadingState(true);

			try {
				const config = {
					...fetchConfig('javascript'),
					body: new FormData(this.form)
				};
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];


				const response = await fetch(`${routes.cart_add_url}`, config);
				const data = await response.json();

				if (data.status) {
					this.errorMessage(data);
					return;
				}

				this.success();
			} catch (error) {
				console.error('Add to cart error:', error);
				this.toggleLoadingState(false);
			}
		}

		toggleLoadingState(isLoading) {
			this.addButtons?.forEach(button => {
				button.classList.toggle('loading', isLoading);
			});
		}

		errorMessage(resp) {
			console.log(resp)
			if (resp.status === 422) {
				// Compact cards have no room for an inline error and it breaks
				// the card layout — surface the message as a toast instead, and
				// skip success() so there's no false "added to cart" feedback.
				if (this.closest('.product-card')) {
					showCartToast(resp.message, 'error');
					updateCartCount();
					updateCartPopup();
					this.toggleLoadingState(false);
					return;
				}
				if(this.closest('.global-error-container')){
					let errorBlock = document.createElement('p');
					errorBlock.classList.add('product-error');
					errorBlock.innerHTML = resp.message
					if(this.closest('.global-error-container').querySelector(`.product-error`)){
						this.closest('.global-error-container').querySelector(`.product-error`).innerHTML = resp.message
					}else{
						this.closest('.global-error-container').prepend(errorBlock);
					}
				}

				this.success();

			}
			this.toggleLoadingState(false);
		}



		success() {
			console.log("Product added to cart")
			this.toggleLoadingState(false);

			updateCartCount();
			updateCartPopup();

			const fromQuickView = !!this.closest('#choose-option-popup');
			const flySource = findFlySource(this);

			if (!document.querySelector('.js-cart-page')) {
				if (fromQuickView) {
					// Keep the quick-view popup open so the customer can add
					// other variants (e.g. different pan sizes). Just confirm with a toast.
					flyToCart(flySource);
					showCartToast();
				} else {
					const behavior = document.body.dataset.cartOpen || 'product_page_only';
					const fromProductPage = !this.closest('.product-card');
					const shouldOpen = behavior === 'always' || (behavior === 'product_page_only' && fromProductPage);
					if (shouldOpen) {
						this.openCartPopup();
					} else {
						flyToCart(flySource);
						showCartToast();
					}
				}
			}
			if(document.querySelector('.js-cart-page cart-item')){
				// On the cart page the list redraws in place (no popup / no
				// reload), so play the decorative fly animation here too —
				// otherwise adds from the recommendation / recently-viewed
				// sliders get no feedback.
				flyToCart(flySource);
				document.querySelector('.js-cart-page ').classList.add('loading')
				document.querySelector('.js-cart-page cart-item').updateCartContent();
			}else if(document.querySelector('.js-cart-page')){
				window.location.reload();
			}
		}

		variantError() {
			console.error('Product variant not selected');
		}

		removeErrorsBlock() {
			// Implementation for removing error blocks
		}
		openCartPopup(){
			const cartPopup = document.querySelector('#cart-popup')
			cartPopup.classList.add('open');
			setTimeout(function () {
				cartPopup.classList.add('animation')
			}, 200);
			lockScrollbar();
		}
	});
}